import React, { useState } from "react";
import { Button, Modal, Tooltip, Dropdown, Menu, message } from "antd";
import { useLocation } from "react-router-dom";
import Loader from "../../../components/Loading/Loader";
import { PieChart } from "@opd/g2plot-react";
import moment from "moment";
import candidate_img from "../../../assets/img/becomeACandidate.png";
import TopAlert from "../../../components/TopNotification/TopAlert";
import {
  EnvironmentOutlined,
  ArrowLeftOutlined,
  ClockCircleOutlined,
  EyeOutlined,
  StarFilled,
  HomeOutlined,
  EditOutlined,
  EllipsisOutlined,
  LoadingOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import jobIconImg from "../../../assets/icons/JobIcon.svg";
import { ReactComponent as BrandIcon } from "../../../assets/icons/BrandIcon.svg";
import { ReactComponent as PostedIcon } from "../../../assets/icons/PostedIcon.svg";
import { ReactComponent as ExpireIcon } from "../../../assets/icons/ExpireIcon.svg";
import { ReactComponent as HoursIcon } from "../../../assets/icons/HoursIcon.svg";
import { ReactComponent as JobTypeIcon } from "../../../assets/icons/JobTypeIcon.svg";
import { ReactComponent as PositionIcon } from "../../../assets/icons/PositionIcon.svg";
import { ReactComponent as YearsIcon } from "../../../assets/icons/YearsIcon.svg";
import { ReactComponent as ContractIcon } from "../../../assets/icons/ContractIcon.svg";
import { formatHoursDisplay } from "../../../shared/helpers";
import { getImageByStateCode } from "../../CompanyProfile/components/cloudinary";
import { DENSITY_COLORS, msgtxt } from "./jobDetailHelpers";
import useJobDetail from "./useJobDetail";
import "./JobDetailNew.css";

export default function JobDetailNew() {
  const location = useLocation();
  const img = location.state?.img;

  const {
    showmodal,
    setshowmodal,
    isDisclaimer,
    piePlot,
    deljobsuccess,
    delete_job_response,
    countDetails,
    jobdetails,
    handleBack,
    handleOk,
    handleCancel,
    favorite,
    handleToggleFavorite,
    bannerImg,
    locationDisplay,
    jobTypeName,
    isContractType,
    workplacePolicyDisplay,
    skills,
    regionCode,
    companyName,
    budgetMin,
    budgetTypeLabel,
    experienceLevelTags,
    extendExp,
    loader,
    DeleteJobHandler,
    EditJobHandler,
    findMatches,
  } = useJobDetail(img);


  // Show a spinner while job data is loading or while navigating between jobs.
  // Using == null (covers both undefined and null) rather than == undefined.
  if (
    jobdetails[0]?.JobOrderId == null ||
    (location?.state?.id && location?.state?.id !== jobdetails[0]?.JobOrderId)
  ) {
    return <Loader />;
  }

  const job = jobdetails[0] || {};
  const externalGigId = job?.ExternalGigId ?? location?.state?.ExternalGigId;
  const hasExternalGigId = externalGigId != null;
  const vmsName = job?.VMS || location?.state?.VMS;
  const vmsLink = job?.VMSLink || location?.state?.VMSLink;

  const handleOpenVmsLink = () => {
    if (vmsLink) {
      window.open(vmsLink, "_blank");
    }
  };

  const handleShareJob = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      message.success("Job link copied to clipboard!");
    });
  };



  const actionMenu = (
    <Menu>
      <Menu.Item key="share" onClick={handleShareJob}>
        Share Job
      </Menu.Item>
      <Menu.Item key="favourite" onClick={handleToggleFavorite}>
        {favorite ? "Remove from Favourites" : "Mark as Favourite"}
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {/* Success / warning notifications */}
      {deljobsuccess && delete_job_response.status == 200 ? (
        <TopAlert
          display={"block"}
          title={"Job successfully deleted"}
          type="success"
        />
      ) : null}

      <div className="jdn-container">
        {isDisclaimer && deljobsuccess && delete_job_response.status == 500 ? (
          <TopAlert
            display={"flex"}
            title={delete_job_response.message}
            type="warning"
          />
        ) : null}

        {/* Delete confirmation modal */}
        <Modal
          onCancel={() => setshowmodal(false)}
          title="Delete this job?"
          className="modalStyle"
          visible={showmodal}
          closable={false}
          footer={null}
          width={400}
          centered
        >
          <div className="jobcard-dlttxt">Do you want to delete this job?</div>
          <div
            style={{
              marginTop: "40px",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              className="jobcard-modalno"
              key="back"
              onClick={handleCancel}
            >
              No, go back
            </Button>
            <Button
              className="jobcard-modalyes"
              key="submit"
              type="primary"
              onClick={handleOk}
            >
              Yes, delete job
            </Button>
          </div>
        </Modal>

        {/* Back button — standalone row */}
        <button className="jdn-back-btn" onClick={handleBack}>
          <ArrowLeftOutlined />
        </button>

        {/* Header row */}
        <div className="jdn-header">
          <div className="jdn-header-left">
            <div className="jdn-company-logo">
              <img src={jobIconImg} alt="company" />
            </div>

            <div className="jdn-title-group">
              <div className="jdn-title">{jobdetails[0]?.Title}</div>
              {hasExternalGigId && vmsName ? (
                <div className="jdn-vms-row">
                  <span className="jdn-vms-tag">{vmsName}</span>
                  <button
                    className="jdn-vms-link-btn"
                    onClick={handleOpenVmsLink}
                    disabled={!vmsLink}
                    type="button"
                  >
                    <LinkOutlined />
                    <span>VMSJOB</span>
                  </button>
                </div>
              ) : null}
              <div className="jdn-subtitle">
                {jobdetails[0]?.FacilityName ? (
                  <>
                    <span className="jdn-facility-name">
                      {jobdetails[0].FacilityName}
                    </span>
                    {jobdetails[0]?.facilityRating?.rating != null &&
                      jobdetails[0].facilityRating.rating !== 0 && (
                        <>
                          <StarFilled className="jdn-star-icon" />
                          <span className="jdn-rating-val">
                            {Number(jobdetails[0].facilityRating.rating).toFixed(1)}
                          </span>
                          {jobdetails[0].facilityRating.reviews ? (
                            <span className="jdn-review-count">
                              ({jobdetails[0].facilityRating.reviews} reviews)
                            </span>
                          ) : null}
                        </>
                      )}
                  </>
                ) : (
                  <>
                    {/* Remote jobs carry no location, so the pin would sit there alone */}
                    {locationDisplay && (
                      <>
                        <EnvironmentOutlined />
                        <span>{locationDisplay}</span>
                      </>
                    )}
                    {jobTypeName && (
                      <span className="jdn-dot-sep">&bull; {jobTypeName}</span>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="jdn-header-actions">
            <button
              className="jdn-icon-btn"
              onClick={EditJobHandler}
              aria-label="Edit"
            >
              <EditOutlined />
            </button>
            <Dropdown
              overlay={actionMenu}
              trigger={["click"]}
              placement="bottomRight"
            >
              <button className="jdn-icon-btn" aria-label="More options">
                <EllipsisOutlined />
              </button>
            </Dropdown>
          </div>
        </div>

        {/* Banner image */}
        <div className="jdn-banner">
          <img
            src={bannerImg}
            alt={jobdetails[0]?.Title}
            onError={(e) => {
              if (
                regionCode &&
                e.target.src !==
                getImageByStateCode(regionCode, "state", companyName)
              ) {
                e.target.src = getImageByStateCode(
                  regionCode,
                  "state",
                  companyName
                );
              } else {
                e.target.src = candidate_img;
              }
            }}
          />
          <div className="jdn-banner-overlay" />
          {jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName && (
            <div className="jdn-banner-top">
              <span
                className={`jdn-banner-status jdn-banner-status--${jobdetails[0].JobOrderStatuses.JobOrderStatusName.toLowerCase()}`}
              >
                {jobdetails[0].JobOrderStatuses.JobOrderStatusName}
              </span>
            </div>
          )}
          {locationDisplay && (
            <div className="jdn-location-badge">
              <EnvironmentOutlined />
              {locationDisplay}
            </div>
          )}
        </div>

        {/* Two-column body */}
        <div className="jdn-body">
          {/* Left column — Job Description */}
          <div className="jdn-card">
            <div className="jdn-card-title">Job Description</div>

            {hasExternalGigId ? (
              <div className="jdn-desc-text">
                {`${job?.FacilityName || "Facility"} is seeking a ${
                  job?.Title || "Title"
                } for a ${
                  job?.JobOrderTypes?.JobOrderTypeName || "N/A"
                } job in ${
                  job?.Location?.LocationWithCountry || "location"
                }`}
                {job?.Shift ? (
                  <div className="jdn-external-shift">Shift: {job.Shift}</div>
                ) : null}
              </div>
            ) : (
              <div
                className="jdn-desc-text"
                dangerouslySetInnerHTML={{
                  __html: msgtxt(jobdetails[0]?.Description),
                }}
              />
            )}

            <div>
              {/* Project */}
              {jobdetails?.[0]?.Project?.ProjectName && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <BrandIcon className="jdn-detail-icon" />
                    Project
                  </span>
                  <span className="jdn-detail-value">
                    {jobdetails?.[0]?.Project?.ProjectName}
                  </span>
                </div>
              )}

              {/* Total Open Positions */}
              {jobdetails[0]?.Position && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <PositionIcon className="jdn-detail-icon" />
                    Total Open Positions
                  </span>
                  <span className="jdn-detail-value">
                    {jobdetails[0]?.Position}
                  </span>
                </div>
              )}

              {/* Hours Required */}
              {budgetMin != null && Number.isFinite(budgetMin) && budgetMin > 0 && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <HoursIcon className="jdn-detail-icon" />
                    Hours Required
                  </span>
                  <span className="jdn-detail-value">
                    {budgetMin} hrs{budgetTypeLabel ? ` /${budgetTypeLabel}` : ""}
                  </span>
                </div>
              )}

              {/* Posted */}
              <div className="jdn-detail-row">
                <span className="jdn-detail-label">
                  <PostedIcon className="jdn-detail-icon" />
                  Posted
                </span>
                <span className="jdn-detail-value">
                  {moment.utc(jobdetails[0]?.Created).format("MMMM DD, YYYY")}
                </span>
              </div>

              {/* Expires */}
              <div className="jdn-detail-row">
                <span className="jdn-detail-label">
                  <ExpireIcon className="jdn-detail-icon" />
                  Expires
                </span>
                <span className="jdn-detail-value">
                  {jobdetails[0]?.ExpiryDate
                    ? moment.utc(jobdetails[0]?.ExpiryDate).format("MMMM DD, YYYY")
                    : ""}
                </span>
              </div>

              {/* Job Type */}
              <div className="jdn-detail-row">
                <span className="jdn-detail-label">
                  <JobTypeIcon className="jdn-detail-icon" />
                  Job Type
                </span>
                <span className="jdn-detail-value">{jobTypeName}</span>
              </div>

              {/* Contract Duration — only for contract types */}
              {isContractType && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <ContractIcon className="jdn-detail-icon" />
                    Contract Duration
                  </span>
                  <span className="jdn-detail-value">
                    {jobdetails[0]?.IdealContractLength?.IdealContractLengthName}
                  </span>
                </div>
              )}

              {/* Years of Experience */}
              {experienceLevelTags?.length > 0 && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <YearsIcon className="jdn-detail-icon jdn-years-icon" />
                    Years of Experience
                  </span>
                  <div className="jdn-exp-tags">
                    {experienceLevelTags.map((tag, i) => (
                      <span key={i} className="jdn-exp-tag">{tag}</span>
                    ))}
                  </div>
                </div>
              )}

              {/* Workplace Policy */}
              {workplacePolicyDisplay && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <HomeOutlined />
                    Workplace Policy
                  </span>
                  <span className="jdn-detail-value">
                    {workplacePolicyDisplay}
                  </span>
                </div>
              )}

              {/* Work Authorization */}
              {jobdetails[0]?.WorkAuthorization?.length > 0 && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <BrandIcon className="jdn-detail-icon" />
                    Work Authorization
                  </span>
                  <div className="jdn-exp-tags">
                    {jobdetails[0].WorkAuthorization.map((item, i) => (
                      <span key={i} className="jdn-exp-tag">{item}</span>
                    ))}
                  </div>
                </div>
              )}

              {/* Tax Terms */}
              {jobdetails[0]?.IdealTerms?.length > 0 && (
                <div className="jdn-detail-row">
                  <span className="jdn-detail-label">
                    <ContractIcon className="jdn-detail-icon" />
                    Tax Terms
                  </span>
                  <div className="jdn-exp-tags">
                    {jobdetails[0].IdealTerms.map((item, i) => (
                      <span key={i} className="jdn-exp-tag">{item}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right column — stacked cards */}
          <div className="jdn-right-column">
            {/* Job Stats card */}
            <div className="jdn-card">
              <div className="jdn-card-title">Job Stats</div>

              {/* <div className="jdn-stats-row">
                <span className="jdn-stats-label">
                  <ReloadOutlined />
                  Max Bid Sent
                </span>
                <span className="jdn-stats-value">
                  {formatHoursDisplay(
                    countDetails?.maxbid?.$numberDecimal ??
                    countDetails?.maxbid,
                    "0 hours"
                  )}
                </span>
              </div> */}

              <div className="jdn-stats-row">
                <span className="jdn-stats-label">
                  <ClockCircleOutlined />
                  Total Bids Sent
                </span>
                <span className="jdn-stats-value">
                  {countDetails?.totalbids}
                </span>
              </div>

              <div className="jdn-stats-row">
                <span className="jdn-stats-label">
                  <EyeOutlined />
                  Total Job Views
                </span>
                <span className="jdn-stats-value">
                  {jobdetails[0]?.views?.length ?? 0}
                </span>
              </div>
            </div>

            {/* Skill Density card — only rendered when skills exist */}
            {skills.length > 0 && (
              <div className="jdn-card">
                <div className="jdn-card-title">Skill Density</div>
                <div className="jdn-density-body">
                  <div className="jdn-density-chart">
                    {piePlot ? <PieChart {...piePlot} /> : null}
                  </div>

                  <div className="jdn-density-legend">
                    {skills.map((item, index) => {
                      const skillName =
                        item?.Skills?.SkillName ?? item?.SkillName ?? "";
                      const pct = item?.SkillPercent;
                      const dotColor =
                        DENSITY_COLORS[index % DENSITY_COLORS.length];
                      return (
                        <div key={index} className="jdn-density-item">
                          <span
                            className="jdn-density-dot"
                            style={{ background: dotColor }}
                          />
                          <Tooltip title={skillName}>
                            <span className="jdn-density-name">
                              {skillName}
                            </span>
                          </Tooltip>
                          <span className="jdn-density-pct">
                            {pct != null ? `${Math.round(pct)}%` : ""}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Action buttons — always visible regardless of skills */}
            <div className="jdn-card">
              {jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName === "Expired" ? (
                <div className="jdn-find-matches-bar">
                  <button
                    className="jobdetail-exp"
                    onClick={() => extendExp()}
                  >
                    {loader ? <LoadingOutlined /> : "Republish Job"}
                  </button>
                </div>
              ) : (
                <div className="jdn-find-matches-bar">
                  <button
                    className="jdn-find-matches-btn"
                    onClick={findMatches}
                  >
                    Find Matches
                  </button>
                  <button
                    className="jobdetail-delete"
                    style={{ marginTop: "10px", width: "100%" }}
                    onClick={() => DeleteJobHandler()}
                  >
                    Delete job listing
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
